import { buildUrl, getDSPId } from "../ReusableFunctions/reusableFunctions";
import { SERVER_URLS } from "../appConstants";
import { getToken } from "./authentication";


export const getRequestsOverview = () => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        `${SERVER_URLS.BACKEND_SERVER}/dsp/overview/requests`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok && response.status === 200) {
        data = await response.json();
        resolve(data);
      } else if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        reject(data?.message || "Something went wrong while getting requests overview.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests overview.");
    }
  });
};

export const getRequestsCount = (userId, fromDate, toDate) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        `${SERVER_URLS.BACKEND_SERVER}/dsp/requests/getRequestsCount?userId=${userId || ""}${fromDate ? `&fromDate=${fromDate || " "}` : " "}${toDate ? `&toDate=${toDate || " "}` : " "}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok && response.status === 200) {
        data = await response.json();
        resolve(data);
      } else if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        reject(data?.message || "Something went wrong while getting requests.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests.");
    }
  });
};

export const getRequests = (userId, filter, pageSize, pageNumber, statusType, searchQuery, fromDate, toDate, pilotId, isOrderByServiceTime) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        `${SERVER_URLS.BACKEND_SERVER}/dsp/requests?pageSize=${pageSize || ""}&pageNumber=${pageNumber || ""
        }&statusType=${statusType || ""}&searchQuery=${searchQuery || ""}&orderBy=${filter?.orderBy || "date_created"}&orderType=${filter?.orderType || "DESC"}&services=${filter?.services?.length > 0 ? encodeURIComponent(JSON.stringify(filter.services)) : ""}&statuses=${filter?.statuses?.length > 0 ? encodeURIComponent(JSON.stringify(filter?.statuses)) : ""}&locations=${filter?.locations?.length > 0 ? encodeURIComponent(JSON.stringify(filter?.locations)) : ""}${userId ? `&userId=${userId}` : ""}${fromDate ? `&fromDate=${fromDate || " "}` : " "}${toDate ? `&toDate=${toDate || " "}` : " "}${pilotId ? `&pilotId=${pilotId}` : ""}${isOrderByServiceTime ? `&isOrderByServiceTime=true` : ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        data = await response.json();
      }
      if (response.ok && response.status === 200) {
        resolve({ requests: data.requests });
      } else if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        reject(data?.message || "Something went wrong while getting requests.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests.");
    }
  });
};

export const getBesRequests = (userId, filter, pageSize, pageNumber, statusType, searchQuery, fromDate, toDate, pilotId, isOrderByServiceTime) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        `${SERVER_URLS.BACKEND_SERVER}/dsp/requests/besRequests?pageSize=${pageSize || ""}&pageNumber=${pageNumber || ""
        }&statusType=${statusType || ""}&searchQuery=${searchQuery || ""}&orderBy=${filter?.orderBy || "date_created"}&orderType=${filter?.orderType || "DESC"}&services=${filter?.services?.length > 0 ? encodeURIComponent(JSON.stringify(filter.services)) : ""}&statuses=${filter?.statuses?.length > 0 ? encodeURIComponent(JSON.stringify(filter?.statuses)) : ""}&locations=${filter?.locations?.length > 0 ? encodeURIComponent(JSON.stringify(filter?.locations)) : ""}${userId ? `&userId=${userId}` : ""}${fromDate ? `&fromDate=${fromDate || " "}` : " "}${toDate ? `&toDate=${toDate || " "}` : " "}${pilotId ? `&pilotId=${pilotId}` : ""}${isOrderByServiceTime ? `&isOrderByServiceTime=true` : ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        data = await response.json();
      }
      if (response.ok && response.status === 200) {
        resolve({ requests: data.requests });
      } else if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        reject(data?.message || "Something went wrong while getting requests.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests.");
    }
  });
};

export const getBesRequest = (req, needDSPDetails, needSalesBy, needUserDetails, needCommentDetails) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        SERVER_URLS.BACKEND_SERVER + `/dsp/requests/bes/${req.id}?${needSalesBy ? `needSalesBy=${needSalesBy}&` : ""}${needUserDetails ? `needUserDetails=${needUserDetails}&` : ""}${needDSPDetails ? `needDSPDetails=${needDSPDetails}&` : ""}${needCommentDetails ? `needCommentDetails=${needCommentDetails}` : ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok && response.status === 200) {
        data = await response.json();
        resolve(data);
      } else if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        reject(data?.message || "Something went wrong while getting requests.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests.");
    }
  });
};

export const getRequest = (req, needDSPDetails, needSalesBy, needUserDetails, needCommentDetails) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        SERVER_URLS.BACKEND_SERVER + `/dsp/requests/${req.type}/${req.id}?${needSalesBy ? `needSalesBy=${needSalesBy}&` : ""}${needUserDetails ? `needUserDetails=${needUserDetails}&` : ""}${needDSPDetails ? `needDSPDetails=${needDSPDetails}&` : ""}${needCommentDetails ? `needCommentDetails=${needCommentDetails}` : ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok && response.status === 200) {
        data = await response.json();
        resolve(data);
      } else if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        reject(data?.message || "Something went wrong while getting requests.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests.");
    }
  });
};
export const updateRequest = (request, type) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        SERVER_URLS.BACKEND_SERVER + `/dsp/requests`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ request: { ...request, type } }),
        }
      );
      if (response.ok && response.status === 200) {
        data = await response.json();
        resolve(data);
      } else if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        reject(data?.message || "Something went wrong while updating request.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while updating request.");
    }
  });
};

export const applyDiscount = ({ id, dsp_discount }) => {
  return new Promise(async (resolve, reject) => {
    resolve()
    // try {
    //   let data;
    //   const token = getToken();
    //   const response = await fetch(
    //     SERVER_URLS.BACKEND_SERVER + `/dsp/requests/applyDiscount`,
    //     {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${token}`,
    //       },
    //       body: JSON.stringify({
    //         id: id,
    //         dsp_discount: dsp_discount
    //       }),
    //     }
    //   );
    //   if (response.ok && response.status === 200) {
    //     data = await response.json();
    //     resolve(data);
    //   } else {
    //     reject(data?.message || "Something went wrong while updating request.");
    //   }
    // } catch (error) {
    //   console.log(error);
    //   reject("Something went wrong while updating request.");
    // }
  });
};

export const getRequestsCountPerDate = (fromDate, toDate, pilotId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        SERVER_URLS.BACKEND_SERVER + `/dsp/requests/dateCount/${encodeURIComponent(fromDate)}/${encodeURIComponent(toDate)}${pilotId ? `?pilotId=${pilotId}` : ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok && response.status === 200) {
        data = await response.json();
        resolve(data);
      } else {
        reject(data?.message || "Something went wrong while getting requests count.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests count.");
    }
  });
};

export const getCrops = () => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        SERVER_URLS.BACKEND_SERVER + `/dsp/requests/getCrops`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok && response.status === 200) {
        data = await response.json();
        resolve(data.crops[0]?.crop_types);
      } else if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        reject(data?.message || "Something went wrong while getting requests.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests.");
    }
  });
};

export const createRequestFromDSP = (request) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        SERVER_URLS.BACKEND_SERVER + `/dsp/requests`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(request)
        }
      );
      data = await response.json();
      if (response.ok && response.status == 201) {
        resolve(data);
      } else if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        reject(response?.status == 400 ? data?.message : "Something went wrong while creating request");
      }
    } catch (error) {
      console.log(error);
      reject(error.message || "Something went wrong while creating request");
    }
  });
};

export const cancelRequest = async (requestId, note, isDebitBESIncentive) => {
  try {
    const token = getToken();
    const url = buildUrl(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/customerSuccessEngineer/dsp/request/cancel`, {
      requestId: requestId ? requestId : undefined,
      note: note ? note : undefined,
      isDebitBESIncentive: isDebitBESIncentive ? isDebitBESIncentive : undefined
    });
    const response = await fetch(url,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token} `,
        },
      }
    );

    const res = await response.json();
    if (!response.ok) {
      throw (res.message || "Something went wrong while getting coupons");
    }
    return res;

  } catch (err) {
    throw (err || "Something went wrong while getting coupons");
  }
}

export const getRequestsPerformanceGraphData = (fromDate, toDate) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      let url = SERVER_URLS.BACKEND_SERVER + `/dsp/requests/requestPerformanceGraphData`
      if (fromDate && toDate) {
        url += `?fromDate=${fromDate}&toDate=${toDate}`
      }
      const response = await fetch(
        url,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok && response.status === 200) {
        data = await response.json();
        resolve(data);
      } else {
        reject(data?.message || "Something went wrong while getting requests performance graph data.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests performance graph data.");
    }
  });
};

export const getServiceWiseRequestsCount = (userId, fromDate, toDate) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        `${SERVER_URLS.BACKEND_SERVER}/aggregator/request/getRequestsCount?userId=${userId || ""}${fromDate ? `&fromDate=${fromDate || " "}` : " "}${toDate ? `&toDate=${toDate || " "}` : " "}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok && response.status === 200) {
        data = await response.json();
        resolve(data);
      } else if (response.status === 204) {
        resolve({ requests: [] });
      } else {
        reject(data?.message || "Something went wrong while getting requests count.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests count.");
    }
  });
};

export const quickRequestUpdateAPI = async (status, pilotId, requestId, droneId, note) => {
  try {
    const token = getToken();
    const url = SERVER_URLS.BACKEND_SERVER + `/dsp/requests/quickActionAgainstRequest`;
    const response = await fetch(url,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          status,
          pilotId,
          requestId,
          droneId,
          note
        })
      }
    );
    const res = await response.json();
    if (!response.ok) {
      throw (res.message);
    }
    return res;
  } catch (err) {
    throw err;
  }
}

export const AcceptBesRequestUpdateAPI = async (requestId) => {
  try {
    const token = getToken();
    const url = SERVER_URLS.BACKEND_SERVER + `/dsp/bes/request/accept`;
    const response = await fetch(url,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          requestId
        })
      }
    );
    const res = await response.json();
    if (!response.ok) {
      throw (res.message);
    }
    return res;
  } catch (err) {
    throw err;
  }
}

export const CancelBesRequestAPI = async (requestId) => {
  try {
    const token = getToken();
    const url = SERVER_URLS.BACKEND_SERVER + `/dsp/bes/request/cancel/${requestId}`;
    const response = await fetch(url,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          requestId
        })
      }
    );
    const res = await response.json();
    if (!response.ok) {
      throw (res.message);
    }
    return res;
  } catch (err) {
    throw err;
  }
}

export const addRequestComment = async (data) => {
  console.log("data", data);
  try {
    const token = await getToken();
    const url = SERVER_URLS.BACKEND_SERVER + `/dsp/requests/comment/create`;
    const response = await fetch(url,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }
    )

    const res = await response.json();
    if (!response.ok) {
      throw (res.message);
    }
    return res;


  } catch (err) {
    throw err;
  }
}


export const deleteRequestComment = async (id) => {
  try {
    const token = await getToken();
    const url = SERVER_URLS.BACKEND_SERVER + `/dsp/requests/comment/delete/${id}`;
    const response = await fetch(url,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    )

    const res = await response.json();
    if (!response.ok) {
      throw (res.message);
    }

    return res;
  } catch (err) {
    throw err;
  }
}


export const getBesIncentives = async (pageNumber, pageSize, searchQuery, status, fromDate, toDate) => {
  try {
    const token = await getToken();
    const url = SERVER_URLS.BACKEND_SERVER + `/dsp/incentives?pageSize=${pageSize || ""}&pageNumber=${pageNumber || ""}&searchQuery=${searchQuery || ""}&status=${status?.length > 0 ? encodeURIComponent(JSON.stringify(status)) : ""}${fromDate ? `&fromDate=${fromDate || " "}` : " "}${toDate ? `&toDate=${toDate || " "}` : " "}`;
    const response = await fetch(url,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    )

    const res = await response.json();
    if (!response.ok) {
      throw (res.message);
    }
    return res;
  } catch (err) {
    throw err;
  }
}


export const getLeadOrderDetails = (id, needSalesBy = false) => {
  return new Promise(async (resolve, reject) => {
    try {
      let data;
      const token = getToken();
      const response = await fetch(
        SERVER_URLS.BACKEND_SERVER + `/aggregator/request/leadOrder/details/${id}?${needSalesBy ? `needSalesBy=${needSalesBy}&` : ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok && response.status === 200) {
        data = await response.json();
        resolve(data?.orderDetails);
      } else if (response.status === 204) {
        resolve({ orderDetails: {} });
      } else {
        reject(data?.message || "Something went wrong while getting requests.");
      }
    } catch (error) {
      console.log(error);
      reject("Something went wrong while getting requests.");
    }
  });
};

export const cancelLeadOrder = async (requestId, note) => {
  try {
    const token = getToken();
    const url = buildUrl(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/operations/requests/cancel/lead/Order`, {
      requestId: requestId ? requestId : undefined,
      note: note ? note : undefined,
    });
    const response = await fetch(url,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token} `,
        },
      }
    );

    const res = await response.json();
    if (!response.ok) {
      throw (res.message || "Something went wrong while getting coupons");
    }
    return res;

  } catch (err) {
    throw (err || "Something went wrong while getting coupons");
  }
}




